// prefix / Suffix / both / /setValue
import { Col, Form, Input, Row } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
const { TextArea } = Input;

const AddText = ({
  label1 = 'Texte principal',
  label2 = 'Texte secondaire',
  placeholder1 = 'Entrez le texte',
  placeholder2 = 'Entrez le texte secondaire',
  showSecondInput = false,
  value,
  onChange,
  value2,
  fieldNamePrefix = [],
  paramKey = 'value',
  paramKey2 = 'value2',
}) => {
  // Local state to avoid re-rendering the entire form on every keystroke
  const [localValue1, setLocalValue1] = useState(value);
  const [localValue2, setLocalValue2] = useState(value2);
  const debounceRef1 = useRef(null);
  const debounceRef2 = useRef(null);

  // Sync local state when external value changes (e.g., reset form)
  useEffect(() => {
    setLocalValue1(value);
  }, [value]);

  useEffect(() => {
    setLocalValue2(value2);
  }, [value2]);

  const handleChange1 = (e) => {
    const newValue = e.target.value;
    setLocalValue1(newValue);

    // Debounce: propagate to parent after 300ms of inactivity
    if (debounceRef1.current) {
      clearTimeout(debounceRef1.current);
    }
    debounceRef1.current = setTimeout(() => {
      onChange?.(newValue, 'value1');
    }, 300);
  };

  const handleChange2 = (e) => {
    const newValue = e.target.value;
    setLocalValue2(newValue);

    // Debounce: propagate to parent after 300ms of inactivity
    if (debounceRef2.current) {
      clearTimeout(debounceRef2.current);
    }
    debounceRef2.current = setTimeout(() => {
      onChange?.(newValue, 'value2');
    }, 300);
  };

  // Propagate immediately on blur (in case user clicks away before debounce fires)
  const handleBlur1 = () => {
    if (debounceRef1.current) {
      clearTimeout(debounceRef1.current);
    }
    onChange?.(localValue1, 'value1');
  };

  const handleBlur2 = () => {
    if (debounceRef2.current) {
      clearTimeout(debounceRef2.current);
    }
    onChange?.(localValue2, 'value2');
  };

  return (
    <Row gutter={16}>
      <Col span={showSecondInput ? 12 : 24}>
        <Form.Item
          label={label1}
          name={[...fieldNamePrefix, paramKey]}
          rules={[
            {
              required: true,
              message: `Veuillez saisir la valeur pour ${label1.toLowerCase()}`,
            },
          ]}
          initialValue={value}
        >
          <TextArea
            placeholder={placeholder1}
            value={localValue1}
            onChange={handleChange1}
            onBlur={handleBlur1}
          />
        </Form.Item>
      </Col>
      {showSecondInput && (
        <Col span={12}>
          <Form.Item
            label={label2}
            name={[...fieldNamePrefix, paramKey2]}
            rules={[
              {
                required: true,
                message: `Veuillez saisir la valeur pour ${label2.toLowerCase()}`,
              },
            ]}
            initialValue={value2}
          >
            <TextArea
              placeholder={placeholder2}
              value={localValue2}
              onChange={handleChange2}
              onBlur={handleBlur2}
            />
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};

export default AddText;
